import axiosPost from "./axiosPost";

export const RNHAreaUpd = async (credentials, data) => {
    const body = {
        service: "RNHAreaUpd",
        params: {
            rnhAreaId: data?.id,
            rnhAreaNombre: data?.name,
            rnhAreaCod: data?.cod,
            rnhZonaId: data?.zonaId,
            rnhAreaWKT: data?.wkt,
            rnhAreaVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
